import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { MODULES } from './modules';
import { APP_CONFIG } from '@/config/app-config';

Vue.use(Vuex);

const StoreModule = {};
Object.keys(APP_CONFIG.stateKey).forEach((key) => {
    StoreModule[key] = MODULES[key];
});

export default new Vuex.Store({
    modules: StoreModule,
    state: {},
    mutations: {},
    actions: {},
    strict: false,
    plugins: [ createPersistedState({paths: [APP_CONFIG.stateKey.cartState], storage: window.localStorage })],
});
